import React, { useContext, useState, useEffect } from "react";
import { Container, Row, Col, Form, InputGroup } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./ViewOffCanvance.css";
import { Context } from "../../../utils/context";
import { useForm, Controller } from "react-hook-form";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import Select from "react-select";
import { CancelButton, SaveButton } from "../../common/Button";
import ModalSave from "../../common/ModelSave";

const ViewOffCanvance = (props) => {
  const [value, setValue] = React.useState("1");
  const handleChange = (event, newValue) => setValue(newValue);

  const { postData, getData, IMG_URL } = useContext(Context);
  const [showModal, setShowModal] = useState({ code: 0, message: "" });

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const dataToSend = new FormData();
      dataToSend.append("stage", data?.stage?.value);
      dataToSend.append("email", getValues("email"));

      const response = await postData(
        `/employee/seller/request/${props.id}`,
        dataToSend,
      );

      setShowModal({ code: response.code, message: response.message });
      props.getDataAll(); // Refresh parent table

      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        props.handleClose();
      }, 1500);
    } catch (error) {
      console.error(error);
    }
  };

  const [data, setData] = useState(null);

  const getSellerData = async () => {
    const res = await getData(
      `/employee/seller-details/s-personal-details/${props.id}`,
    );
    if (res?.success) {
      setData(res.data);
      reset(res.data);
    }
  };

  useEffect(() => {
    if (props.id) getSellerData();
  }, [props.id]);

  if (!data) return <div className="text-center mt-5">Loading...</div>;

  const sellerDetail = data.seller_detail || {};
  const bankDetail = data.seller_bank_detail || {};
  const categories = data.seller_categories || [];

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%", height: "auto" }}
        placement="end"
        onHide={props.handleClose}
        className="offcan"
      >
        <Container fluid className="tabss-main">
          <Offcanvas.Header closeButton></Offcanvas.Header>
          <Offcanvas.Body>
            <Card className="shadow-lg p-3 mb-5 bg-white rounded">
              <Card.Body>
                <Card.Title>
                  <h3>Seller Details</h3>
                </Card.Title>

                <Box sx={{ width: "100%", typography: "body1" }}>
                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList onChange={handleChange}>
                        <Tab label="Personal Details" value="1" />
                        <Tab label="Store Details" value="2" />
                        <Tab label="Certification Details" value="3" />
                        <Tab label="Documents Details" value="4" />
                        <Tab label="Bank Details" value="5" />
                      </TabList>
                    </Box>

                    {/* Personal Details */}
                    <TabPanel value="1">
                      <h5>
                        {" "}
                        <b>Personal Details</b>
                      </h5>
                      <Row>
                        <Col lg={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>First Name</Form.Label>
                            <Form.Control
                              type="text"
                              value={data?.first_name || ""}
                              disabled
                            />
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>Contact Number</Form.Label>
                            <Form.Control
                              type="text"
                              value={data?.contact_no || ""}
                              disabled
                            />
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                              type="text"
                              value={data?.email || ""}
                              disabled
                            />
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>Logo</Form.Label>
                            <div className="image-boxes-main">
                              <img
                                src={IMG_URL + sellerDetail?.logo}
                                alt="GST"
                                className="image-boxes"
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </TabPanel>

                    {/* Store Details */}
                    <TabPanel value="2">
                      <h5>
                        <b>Store Details</b>
                      </h5>
                      <Row>
                        <Col md={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>Store Name</Form.Label>
                            <Form.Control
                              type="text"
                              value={sellerDetail?.shop_name || ""}
                              disabled
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>Whatsapp No.</Form.Label>
                            <Form.Control
                              type="text"
                              value={sellerDetail?.whatsapp_number || ""}
                              disabled
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>Address</Form.Label>
                            <Form.Control
                              type="text"
                              value={sellerDetail?.store_address || ""}
                              disabled
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>Area</Form.Label>
                            <Form.Control
                              type="text"
                              value={sellerDetail?.area || ""}
                              disabled
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>City</Form.Label>
                            <Form.Control
                              type="text"
                              value={sellerDetail?.city?.name || ""}
                              disabled
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>Pincode</Form.Label>
                            <Form.Control
                              type="text"
                              value={sellerDetail?.pincode?.name || ""}
                              disabled
                            />
                          </div>
                        </Col>
                      </Row>

                      {/* Categories */}
                      {categories.length > 0 && (
                        <div className="mt-4">
                          <h5>Business Categories</h5>
                          <div className="d-flex flex-wrap gap-2">
                            {categories.map((cat) => (
                              <span
                                key={cat.id}
                                className="badge bg-primary fs-6"
                              >
                                Category {cat?.category?.name}
                              </span>
                            ))}
                          </div>
                        </div>
                      )}
                    </TabPanel>

                    {/* Certification Details */}
                    <TabPanel value="3">
                      <h3>Certification Details</h3>
                      <Row>
                        <Col lg={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>Certification Name</Form.Label>
                            <Form.Control
                              type="text"
                              value={sellerDetail?.certification_name || ""}
                              disabled
                            />
                          </div>
                        </Col>

                        {sellerDetail?.license_image && (
                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Form.Label>License Image</Form.Label>
                              <div className="image-boxes-main">
                                <img
                                  src={IMG_URL + sellerDetail?.license_image}
                                  alt="GST"
                                  className="image-boxes"
                                />
                              </div>
                            </div>
                          </Col>
                        )}
                        {/* <Col lg={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>License</Form.Label>
                            <Form.Control
                              type="text"
                              value={sellerDetail?.license || ""}
                              disabled
                            />
                          </div>
                        </Col> */}
                        {/* <Col lg={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>License Type</Form.Label>
                            <Form.Control
                              type="text"
                              value={sellerDetail?.license_type || ""}
                              disabled
                            />
                          </div>
                        </Col> */}
                        {/* <Col lg={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>Name on License</Form.Label>
                            <Form.Control
                              type="text"
                              value={sellerDetail?.license_name || ""}
                              disabled
                            />
                          </div>
                        </Col> */}
                        {/* <Col lg={8}>
                          <div className="main-form-section mt-4">
                            <Form.Label>Address in License</Form.Label>
                            <Form.Control
                              type="text"
                              value={sellerDetail?.license_address || ""}
                              disabled
                            />
                          </div>
                        </Col> */}
                        <Col lg={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>Registration No</Form.Label>
                            <Form.Control
                              type="text"
                              value={sellerDetail?.registration_number || ""}
                              disabled
                            />
                          </div>
                        </Col>
                        {/* <Col lg={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>Expiry Date</Form.Label>
                            <Form.Control
                              type="text"
                              value={
                                sellerDetail?.license_expiry_date
                                  ? new Date(
                                      sellerDetail?.license_expiry_date
                                    ).toLocaleDateString()
                                  : ""
                              }
                              disabled
                            />
                          </div>
                        </Col> */}
                      </Row>
                    </TabPanel>

                    {/* Documents Details */}
                    <TabPanel value="4">
                      <h3>Documents Details</h3>
                      <Row>
                        {bankDetail?.gst_no && (
                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Form.Label>GST Number</Form.Label>
                              <Form.Control
                                type="text"
                                value={bankDetail?.gst_no || ""}
                                disabled
                              />
                            </div>
                          </Col>
                        )}
                        <Col lg={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>PAN Number</Form.Label>
                            <Form.Control
                              type="text"
                              value={bankDetail?.pan_no || ""}
                              disabled
                            />
                          </div>
                        </Col>
                        <Col lg={4}></Col>

                        {bankDetail?.gst_image && (
                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Form.Label>Uploaded GST Document</Form.Label>
                              <div className="image-boxes-main">
                                <img
                                  src={IMG_URL + bankDetail?.gst_image}
                                  alt="GST"
                                  className="image-boxes"
                                />
                              </div>
                            </div>
                          </Col>
                        )}

                        {bankDetail?.pan_image && (
                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Form.Label>Uploaded PAN Document</Form.Label>
                              <div className="image-boxes-main">
                                <img
                                  src={IMG_URL + bankDetail?.pan_image}
                                  alt="PAN"
                                  className="image-boxes"
                                />
                              </div>
                            </div>
                          </Col>
                        )}
                      </Row>
                    </TabPanel>

                    {/* Bank Details */}
                    <TabPanel value="5">
                      <h3>Bank Details</h3>
                      <Row>
                        <Col lg={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>Bank Name</Form.Label>
                            <Form.Control
                              type="text"
                              value={bankDetail?.bank_name || ""}
                              disabled
                            />
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>Account Name</Form.Label>
                            <Form.Control
                              type="text"
                              value={bankDetail?.benificary_name || ""}
                              disabled
                            />
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>Account Number</Form.Label>
                            <Form.Control
                              type="text"
                              value={bankDetail?.acc_no || ""}
                              disabled
                            />
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>IFSC Code</Form.Label>
                            <Form.Control
                              type="text"
                              value={bankDetail?.ifsc_code || ""}
                              disabled
                            />
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>Bank State</Form.Label>
                            <Form.Control
                              type="text"
                              value={bankDetail?.bank_state || ""}
                              disabled
                            />
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>Bank City</Form.Label>
                            <Form.Control
                              type="text"
                              value={bankDetail?.bank_city || ""}
                              disabled
                            />
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>Bank Branch</Form.Label>
                            <Form.Control
                              type="text"
                              value={bankDetail?.bank_branch || ""}
                              disabled
                            />
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="main-form-section mt-4">
                            <Form.Label>Beneficiary Name</Form.Label>
                            <Form.Control
                              type="text"
                              value={bankDetail?.benificary_name || ""}
                              disabled
                            />
                          </div>
                        </Col>

                        <Col lg={4}></Col>

                        {bankDetail?.passbook_photo && (
                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Form.Label>Passbook Photo</Form.Label>
                              <div className="image-boxes-main">
                                <img
                                  src={IMG_URL + bankDetail?.passbook_photo}
                                  alt="Passbook"
                                  className="image-boxes"
                                />
                              </div>
                            </div>
                          </Col>
                        )}

                        {bankDetail?.kyc_photo && (
                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Form.Label>KYC Document</Form.Label>
                              <div className="image-boxes-main">
                                <img
                                  src={IMG_URL + bankDetail?.kyc_photo}
                                  alt="KYC"
                                  className="image-boxes"
                                />
                              </div>
                            </div>
                          </Col>
                        )}
                      </Row>
                    </TabPanel>
                  </TabContext>
                </Box>
              </Card.Body>
            </Card>

            {/* Action Section */}
            <Row className="mt-5 pb-3">
              <Col md={4}>
                <div className="main-form-section mb-3">
                  <Row className="justify-content-center">
                    <Form.Group>
                      <Form.Label>Take an action</Form.Label>
                      <Controller
                        name="stage"
                        control={control}
                        rules={{ required: "Please select an action" }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={[
                              { value: "Approved", label: "Approve" },
                              { value: "Rejected", label: "Reject" },
                            ]}
                            styles={{
                              control: (base) => ({
                                ...base,
                                borderColor: errors.stage
                                  ? "red"
                                  : base.borderColor,
                              }),
                            }}
                          />
                        )}
                      />
                      {errors.stage && (
                        <p style={{ color: "red" }}>{errors.stage.message}</p>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>
            </Row>

            <div className="mt-5 pb-3">
              <div className="d-flex justify-content-center">
                <CancelButton name="Back" handleClose={props.handleClose} />
                <SaveButton name="Save" handleSubmit={handleSubmit(onSubmit)} />
              </div>
            </div>
          </Offcanvas.Body>
        </Container>
      </Offcanvas>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default ViewOffCanvance;
